// Lobby Actions
export const disconnect = 'disconnect';
export const endTurn = 'endTurn';
export const newPlayer = 'newPlayer';
export const resumeGame = 'resumeGame';
export const startGame = 'startGame';
export const startSinglePlayerGame = 'startSinglePlayerGame';

// Game Actions
export const adminUpdateState = 'adminUpdateState';
export const advanceSummitResolution = 'advanceSummitResolution';
export const buyBattery = 'buyBattery';
export const buyFactory = 'buyFactory';
export const buyPR = 'buyPR';
export const discardEquipment = 'discardEquipment';
export const donateEnergy = 'donateEnergy';
export const joinGameRoom = 'joinGameRoom';
export const makeDecision = 'makeDecision';
export const makeDecisionSummitDraftCardId = 'makeDecisionSummitDraftCardId';
export const makeDecisionTurnOrder = 'makeDecisionTurnOrder';
export const playCard = 'playCard';
export const playCardWithId = 'playCardWithId';
export const playEquipment = 'playEquipment';
export const playEquipmentById = 'playEquipmentById';
export const playSummitCard = 'playSummitCard';
export const stealCarbon = 'stealCarbon';
export const storeEnergy = 'storeEnergy';
export const updateGameState = 'updateGameState';
export const updatePlayers = 'updatePlayers';
